require('../polly/presigner');


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/lib/services/polly.js
// module id = 280
// module chunks = 0